"use client";
import { Logo } from "@/components/svgs";

import { Button } from "@/components/ui/button";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { removeLeadingHashNumber } from "@/lib/utils";
import { env } from "@/types/env";
import Link from "next/link";
import React from "react";
import data from "../../../../data/static-categories.json";
import { itemsLeft, itemsProps, itemsRight } from "./data";
import MiniCart from "./mini-cart";

export default function Navigation() {
  return (
    <div className="flex  gap-4 xl:gap-20 justify-center w-full items-center">
      <NavigationMenu>
        <NavigationMenuList className="flex gap-4 xl:gap-10 w-full items-center">
          <NavigationMenuItem>
            <Link href="/vara-provningar" className="text-base">
              <NavigationMenuTrigger className="bg-primary text-primary-foreground text-base hover:underline">
                Våra provningar
              </NavigationMenuTrigger>
            </Link>
            <NavigationMenuContent className="bg-primary border-primary">
              <menu className="grid gap-4 gap-x-16 px-8 py-4  max-full lg:grid-cols-[1fr_1fr_1fr]">
                {data?.map(
                  (child: { id: string; name: string; slug: string }) => (
                    <NavigationMenuItem
                      key={child.id}
                      className="text-primary-foreground"
                    >
                      <NavigationMenuLink
                        asChild
                        className="bg-primary hover:underline whitespace-nowrap text-base"
                      >
                        <Link href={`/vara-provningar/${child.slug}`}>
                          {child?.name && removeLeadingHashNumber(child.name)}
                        </Link>
                      </NavigationMenuLink>
                    </NavigationMenuItem>
                  )
                )}
              </menu>
            </NavigationMenuContent>
          </NavigationMenuItem>
          {itemsLeft?.map((item) =>
            item.children ? (
              <LinkDropdown key={item.id} item={item} />
            ) : (
              <LinkItem key={item.id} item={item} />
            )
          )}
        </NavigationMenuList>
      </NavigationMenu>

      <Link href="/" className="flex gap-3 justify-center items-center px-10">
        <Logo className="w-10 h-10" />
        <span className="font-poppins uppercase font-bold text-primary-foreground">
          {env.NEXT_PUBLIC_SITE_TITLE}
        </span>
      </Link>

      <NavigationMenu>
        <NavigationMenuList className="flex w-full gap-4 xl:gap-10 items-center ">
          {itemsRight?.map((item) =>
            item.children ? (
              <LinkDropdown key={item.id} item={item} />
            ) : (
              <LinkItem key={item.id} item={item} />
            )
          )}
          <li>
            <Button variant="outlineGold" effect="gooeyLeft" size="sm">
              <Link href="/datum">Boka provning</Link>
            </Button>
          </li>
          <li className="flex items-center justify-center">
            <MiniCart />
          </li>
        </NavigationMenuList>
      </NavigationMenu>
    </div>
  );
}

const LinkItem = ({ item }: { item: itemsProps }) => (
  <NavigationMenuItem className="text-primary-foreground">
    <NavigationMenuLink
      asChild
      className="bg-primary hover:underline text-base"
    >
      <Link href={item.href}>{item.title}</Link>
    </NavigationMenuLink>
  </NavigationMenuItem>
);

const LinkDropdown = ({ item }: { item: itemsProps }) => (
  <NavigationMenuItem>
    {item?.href ? (
      <Link href={item.href}>
        <NavigationMenuTrigger className="bg-primary text-primary-foreground hover:underline text-base">
          {item.title}
        </NavigationMenuTrigger>
      </Link>
    ) : (
      <NavigationMenuTrigger className="bg-primary text-primary-foreground hover:underline text-base">
        {item.title}
      </NavigationMenuTrigger>
    )}
    <NavigationMenuContent className="bg-primary border-primary">
      <menu className="grid gap-3 p-4 md:w-[400px] lg:w-[500px] lg:grid-cols-[.75fr_1fr]">
        {item.children?.map((child: itemsProps) => (
          <LinkItem key={child.id} item={child} />
        ))}
      </menu>
    </NavigationMenuContent>
  </NavigationMenuItem>
);
